import { render } from "./IllnessDialog.vue?vue&type=template&id=271885fc"
import script from "./IllnessDialog.vue?vue&type=script&lang=js"
export * from "./IllnessDialog.vue?vue&type=script&lang=js"

import "./IllnessDialog.vue?vue&type=style&index=0&id=271885fc&lang=css"

import exportComponent from "C:\\Users\\Bodnár Lajos\\Documents\\Work\\Vue.JS\\otthonapolo2020-FE-V3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__